Customer.Users ||= {}

class Customer.Users.ProfileMergerView extends Backbone.View
  template: JST['backbone/templates/customer/users/merge_profiles']
  className: 'tab-pane'
  id: 'merge-profile'

  events:
    'click #search_profile': '_onSearch'
    'click #continue': '_onContinue'
    'keyup #text_search': '_onKeyPress'
    'change input:checkbox': '_onChange'
    'click #profile-merge-close': 'close'
    'click .profile-merge-go-back': '_openDefaultFooter'
    'click #profile-merge-ok': '_openMergeFooter'
    'click #profile-merge-exclude': '_openExcludeFooter'
    'click #profile-merge-ok-confirm': 'merge'
    'click #profile-merge-exclude-confirm': 'exclude'

  initialize: (@options = {}) ->
    @profile = @options.profile

  render: ->
    @$el.html(@template())
    @clearMergeScreen()
    @

  _onKeyPress: (event) =>
    if event.keyCode == 13 # ENTER
      @$el.find('#search_profile').click()

  _onSearch: =>
    @openProfilesList()
    @clearMergeScreen()
    @$el.addClass('processing')
    $.ajax
      type: 'POST'
      url: '/profiles/api/search'
      data: { text: @$el.find('#text_search').val() }
      success: @_render_profiles
      error: @_error

  _onContinue: =>
    profileToMerge = @$el.find('#profile-list input[name=profile]:checked').val()
    return unless profileToMerge
    @extendedProfile = new Profile.UserProfile.ExtendedUserProfile @profileToMerge
    @$el.html(@template())
    @openMergeScreen()
    @extendedProfiles =  @_mergeCandidateCollection()
    @definition = @extendedProfiles.at(0).get('editable_attributes')
    @addCandidates()
    @$el.find('.selector').hide()
    @$el.find('.mergeable-profile input:checkbox').prop('disabled', false)
    @$el.find('.mergeable-profile .selector input:checkbox').prop('checked', true)
    @_validate()

  _onChange: =>
    @_openDefaultFooter()
    @_validate()

  _validate: =>
    invalidCodes = @invalidAttributeCodes()
    @_toggleError(invalidCodes)
    @_updateErrorMessage(invalidCodes)
    @_toggleMergeButton(invalidCodes)

  invalidAttributeCodes: =>
    codes = []
    @definition.forEach (definition) =>
      return if definition.get('multiple')

      code = definition.get('code')
      values = new Set
      for view in @mergeableProfileViews
        values.add(value.value) for value in view.getValues(code)
      codes.push(code) if values.size > 1
    codes

  merge: =>
    @$el.addClass('processing')
    $.ajax
      type: 'POST'
      url: '/profiles/api/merge'
      contentType: 'application/json',
      data: JSON.stringify(
        custom_attributes: @getCustomAttributes()
        social_users_to_merge: @getSocialUsersToMerge()
        main_social_user: @profile.mainSocialUser().get('id')
      )
      success: (response) =>
        @$el.find('.processing').hide()
        showSuccess(I18n.t('user_profiles.merge.success'))
        @trigger('profile:merged', response)
      error: =>
        @$el.find('.processing').hide()
        showError(I18n.t('generic_error_message'))
        @$el.find('.tab-content').show()
    @clearMergeScreen()

  getSocialUsersToMerge: =>
    socialUsers = []
    for view in @mergeableProfileViews
      socialUsers = socialUsers.concat(view.getSocialUsersToMerge())
    socialUsers

  getCustomAttributes: =>
    attributes = []
    @definition.forEach (definition) =>
      values = []
      code = definition.get('code')
      type = definition.get('attribute_type_name')
      for view in @mergeableProfileViews
        values = values.concat(view.getValues(code))
      unless values.length == 0
        attributes.push(code: code, type: type, values: values)
    attributes

  _render_profiles: (response) =>
    @$el.find('#continue').show(50)
    @$el.removeClass('processing')
    for profile in response.profiles
      @profileToMerge = profile
      continue if profile.id == @profile.id
      profileRow = new Customer.Users.ProfileRowView({ profile: profile })
      @$el.find('#profile-list').append(profileRow.render().el)
    @$el.find('.nano').nanoScroller()

  _error: (response) =>
    errorMsg = $('<div></div>').text(response.message).addClass('profile-error')
    @$el.removeClass('processing').html(response.message)

  _mergeCandidateCollection: =>
    new Profile.UserProfile.MergeCandidateCollection(
      [@extendedProfile]
      source: @profile.mainSocialUser().get('source')
      social_network_id: @profile.mainSocialUser().get('social_network_id')
    )

  addCandidates: =>
    @mergeableProfileViews = []
    @mergeableProfileViews.push(new Customer.Users.MainMergeableProfileView(@profile, @definition))
    @extendedProfiles.forEach (profile) =>
      @mergeableProfileViews.push(new Customer.Users.MergeableProfileView(profile, @definition))

    for view in @mergeableProfileViews
      @$el.find('#profiles').append(view.render().el)

    @$el.find('.processing').hide()
    @$el.find('.tab-content').show()

  _openFooter: ({className}) =>
    @$el.find(".footer-container.#{className}").show()
    @$el.find(".footer-container:not(.#{className})").hide()

  _openDefaultFooter: =>
    @_openFooter className: 'default'

  _openMergeFooter: =>
    @_openFooter className: 'confirm-merge-ok'

  _openExcludeFooter: =>
    @_openFooter className: 'confirm-merge-exclude'

  _toggleError: (invalidCodes) =>
    errorSelector = ''
    notErrorSelector = '.attribute'
    for code in invalidCodes
      errorSelector += ".attribute[data-code='#{code}'] input:checkbox,"
      notErrorSelector += "[data-code!='#{code}']"
    errorSelector = errorSelector.slice(0, -1)
    notErrorSelector += ' input:checkbox'

    @$el.find(errorSelector).addClass('error')
    @$el.find(notErrorSelector).removeClass('error')

  _updateErrorMessage: (invalidCodes) =>
    $errorMessage = @$el.find('.error-message')
    unless invalidCodes.length
      $errorMessage.html('')
      return
    $errorMessage.html(I18n.t(
      'user_profiles.merge.duplicate_unique_values',
      count: @_countAttributes()
    ))

  _toggleMergeButton: (invalidCodes) =>
    disabled = invalidCodes.length > 0 or @getSocialUsersToMerge().length < 1
    @$el.find('#profile-merge-ok').prop('disabled', disabled)


  openMergeScreen: =>
    @$el.find('#profile-list').hide()
    @$el.find('#profile-merge').show()

  openProfilesList: =>
    @$el.find('#profile-list').show()
    @$el.find('#profile-merge').hide()

  clearMergeScreen: =>
    @$el.find('#profiles').empty()
    @$el.find('#profile-merge').hide()
    @_openDefaultFooter()
    @$el.find('#profile-list').show()
    @$el.removeClass('processing')

  _countAttributes: =>
    elements = @$el.find('.attribute input:checked.error:enabled')
    return new Set(Array.from(elements.map((index, element) -> element.dataset.code))).size

  exclude: =>
    @clearMergeScreen()
